<template>
  <ul id="menu-language-prompt-list">
    <li class="menu-language-prompt-row" @click="rowClicked('ja_JP')">
      <button type="button">日本語</button>
    </li>
    <li class="menu-language-prompt-row" @click="rowClicked('zh_TW')">
      <button type="button">繁體中文(台灣)</button>
    </li>
  </ul>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "component-menu-language-list",
  methods: {
    rowClicked(language: "zh_TW" | "ja_JP") {
      this.$emit("row-clicked", language);
    },
  },
});
</script>

<style scoped lang="scss">
.menu-language-prompt-row {
  cursor: pointer;
  font-weight: normal;
  height: 44px;
  overflow-x: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  width: calc(100% - 16px);
  font-size: 12px;
  line-height: 14px;
  color: $text;
  padding-left: 16px;

  &:hover {
    background-color: $lavender;
  }

  button {
    height: 100%;
    width: calc(100% - 16px);
    background-color: transparent;
    appearance: auto;
    -webkit-appearance: auto;
    text-align: left;
    &:focus {
      outline: revert;
    }
  }
}
</style>
